export const NUMBER_OF_INITIAL_FRIENDS_FETCHED = 50
